import { Link } from "react-router-dom";

export default function StartPage() {
  return (
    <main
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background:
          "linear-gradient(to bottom right, #F8FAFC, #EEF2FF)",
        fontFamily: "Inter, sans-serif",
      }}
    >
      <div
        style={{
          textAlign: "center",
          maxWidth: 900,
          padding: 24,
        }}
      >
        <div
          style={{
            display: "inline-block",
            padding: "10px 20px",
            borderRadius: 999,
            background: "#fff",
            border: "1px solid #E5E7EB",
            color: "#6366F1",
            fontWeight: 600,
            marginBottom: 28,
          }}
        >
          AI Learning Companion
        </div>

        <h1
          style={{
            fontSize: 84,
            fontWeight: 800,
            color: "#0C233F",
            marginBottom: 24,
            lineHeight: 1,
          }}
        >
          EarSketch AI
        </h1>

        <p
          style={{
            fontSize: 24,
            color: "#475569",
            marginBottom: 48,
          }}
        >
          Learn coding through music with AI learning companion.
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 20,
            marginBottom: 40,
          }}
        >
          <Link
            to="/onboarding"
            style={{
              padding: "18px 40px",
              borderRadius: 20,
              background: "#0C233F",
              color: "white",
              textDecoration: "none",
              fontWeight: 600,
            }}
          >
            Quick Tour
          </Link>

          <Link
            to="/chat"
            style={{
              padding: "18px 40px",
              borderRadius: 20,
              background: "white",
              color: "#111827",
              textDecoration: "none",
              fontWeight: 600,
              border: "1px solid #E5E7EB",
            }}
          >
            Go to Chat
          </Link>
        </div>

        <p
          style={{
            color: "#94A3B8",
            fontSize: 16,
          }}
        >
          Learn step-by-step. Explore creatively.
        </p>
      </div>
    </main>
  );
}
